/* eslint-disable */
/**
 * AnalyticsService
 * @class AnalyticsService
 */
class AnalyticsService {
  /**
   * The `AnalyticsServiceAdapterContract` interface that will be used for connecting to varius analytics platforms
   * @type {AnalyticsServiceAdapterContract}
   * @memberof AnalyticsService
   */
  analyticsAdapter;

  /**
   * Creates an instance of `AnalyticsService`
   * @param {AnalyticsServiceCreateDto} dto The params required to create an instance of `AnalyticsService`
   * @memberof AnalyticsService
   */
  constructor({ analyticsAdapter }) {
    this.analyticsAdapter = analyticsAdapter;
  }

  /**
   * Add an Analytics script to the page
   * @returns {void} void
   * @memberof AnalyticsAdapter
   */
  addScript = () => {
    return this.analyticsAdapter.addScript();
  };

  /**
   * Track an event
   * @param {AnalyticsEvent} event The event to track
   * @returns {void} void
   * @memberof MockAnalyticsService
   */
  track = (event) => {
    return this.analyticsAdapter.track(event);
  };
}

export default AnalyticsService;
